import type { ReactNode } from 'react'
import { Link } from 'react-router'
import { useMessages } from '@/features/language/use-language'

interface LegalPageProps {
  title: string
  effectiveDate: string
  children: ReactNode
}

/**
 * 약관과 처리방침이 함께 쓰는 문서 화면.
 *
 * 로그인 전에도 닿는 자리라 앱 레이아웃 밖에 선다. 읽는 것이 전부인 화면이므로 본문 폭을
 * 좁게 잡고 줄 간격을 넉넉히 둔다.
 */
export function LegalPage({ title, effectiveDate, children }: LegalPageProps) {
  const m = useMessages()

  return (
    <div className="bg-canvas text-ink min-h-full">
      <div className="mx-auto max-w-2xl px-5 pt-8 pb-20">
        <Link to="/login" className="text-ink-muted text-sm">
          {m.legal.document.back}
        </Link>

        <h1 className="mt-6 font-serif text-2xl tracking-tight">{title}</h1>
        <p className="text-ink-muted mt-2 text-sm">
          {m.legal.document.effectiveDate(effectiveDate)}
        </p>

        <div className="mt-8 flex flex-col gap-8">{children}</div>
      </div>
    </div>
  )
}

interface LegalSectionProps {
  heading: string
  children: ReactNode
}

export function LegalSection({ heading, children }: LegalSectionProps) {
  return (
    <section className="flex flex-col gap-3">
      <h2 className="text-lg font-medium">{heading}</h2>
      <div className="text-ink flex flex-col gap-3 text-[15px] leading-[1.8]">{children}</div>
    </section>
  )
}

export function LegalList({ items }: { items: readonly string[] }) {
  return (
    <ul className="flex list-disc flex-col gap-2 pl-5">
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  )
}
